// src/pages/ContactPage.js
import React from "react";
import "./ContactPage.css";
import Header from "../Header/Header";
import FeedbackSection from "./FeedbackSection";
import MovingTicker from "../Header/MovingTicker";
import { motion } from "framer-motion";

const ContactPage = () => {
  return (
    <div>
      <div className="ticker-fixed">
        <MovingTicker>
          <>
            Millions of tax filers miss out on benefits simply because the rules
            aren’t clear. This isn’t the usual tax education — for that you can
            visit
            <a
              href="https://apps.irs.gov/app/understandingTaxes/teacher/hows.jsp"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#0f62fe",
                textDecoration: "underline",
                marginLeft: "6px",
              }}
            >
              the IRS Understanding Taxes site
            </a>
            . This explains the stages professionals usually charge money to walk
            people through.
          </>
        </MovingTicker>
      </div>

      <div className="min-h-screen bg-gradient-to-b from-orange-100 via-orange-50 to-slate-50 text-slate-900">
        <Header />

        <div className="contact-wrapper">
          <section className="mx-auto max-w-5xl px-6 py-24 text-center">
            <p className="text-2xl font-medium text-slate-900 mb-2" style={{marginBottom: "20px"}}>
              When the tax rules aren’t clear, families miss out — sometimes by
              hundreds or thousands a year.
            </p>

            <p className="max-w-2xl mx-auto text-lg text-slate-700 mb-6">
              And this can repeat every year, quietly adding up over time.
            </p>

            <motion.h1
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-5xl font-bold mb-6 text-slate-900"
            >
              What if there were a plain-language tax guide? 
            </motion.h1>
          </section>
 <p className="contact-subtitle" style={{marginBottom: "80px"}}>
              Hope it helps. 
            </p>
          <section className="contact-hero">
            
            <p className="contact-subtitle">
              Share feedback, topics you want covered or shared with others.
            </p>
          </section>

          <section className="contact-form-section">
            <div className="contact-form-placeholder">
              <FeedbackSection
                title="Contact Us"
                text=""
                collectionName="contact"
                source="contact-page"
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
